import Vue from 'vue'
import App from './App.vue'
import router from './router'
import storage from '@/router/router'
import store from './store'
import './style/index.scss'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { preventReClick } from '@/utils/plugins';
import VueCookies from 'vue-cookies'
import axios from 'axios'
import bus from './utils/bus.js';
import * as filters from '@/utils/filters'
import globalFunc from '@/utils/globalFunc'
import { showLoading, hideLoading } from './router/loading'

Vue.config.productionTip = false
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.use(globalFunc)

Vue.prototype.$http = axios
Vue.prototype.$store = store
Vue.prototype.$storage = storage
Vue.prototype.$bus = bus


axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; // Content-Type: application/x-www-form-urlencoded：请求体中的数据会以普通表单形式（键值对）发送到后端
axios.defaults.retry = 3;
axios.defaults.retryDelay = 1000;
axios.defaults.shouldRetry = (error) => true; //重试条件，默认只要是错误都需要重试
axios.defaults.baseURL = '/api_push'

// 维护一个添加修改类型的接口数组用来设置加载loading 数组里的每一项都是需要设置加载中的接口地址
const loadingArr = []
    // 请求拦截器
axios.interceptors.request.use((config) => {
        // 遍历
        if (loadingArr.length !== 0 && loadingArr) {
            loadingArr.some(url => {
                if (url === config.url) {
                    showLoading()
                    return true
                }
            })
        }
        return config
    }, (error) => {
        ElementUI.Message({
            message: `请求超时`,
            type: 'error'
        })
        return Promise.reject(error)
    })
    // 添加一个响应拦截器
axios.interceptors.response.use(res => {
    let statusCode = res.data.code;
    if (statusCode == undefined || statusCode == 200) {
        hideLoading()
        return res
    } else if (statusCode === 1002) { // 登录过期
        hideLoading()
        ElementUI.Message({
            message: '登录过期！',
            type: 'error'
        })
        store.state.userData = {};
        router.replace({ path: "/login" });
        sessionStorage.clear();
        localStorage.clear();
    } else {
        hideLoading()
        console.log('响应拦截器拦截到的错误信息', res.data.message);
        ElementUI.Message({
            message: res.data.message,
            type: 'error'
        })
    }
}, error => {
    if (error.response && error.response.status && error.response.status == 504) {
        ElementUI.Message.error('服务器错误');
    }
    return Promise.reject(error)
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')